import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  AfterViewInit,
  ChangeDetectorRef
} from '@angular/core'
import { AuthService, User } from '@auth0/auth0-angular'
import { Store } from '@ngrx/store'
import { Router, ActivatedRoute } from '@angular/router'
import { catchError, filter, switchMap, take, tap } from 'rxjs/operators'

import { jwtDecode, JwtPayload } from 'jwt-decode'
import * as fromAuthActions from '../../../core/auth/auth.actions'
import { combineLatest, EMPTY, forkJoin, from, of, Subject } from 'rxjs'
import { AuthResponse } from '../../../core/auth/auth.model'
import { ErrorMessageService } from '../error-message.service'

export interface ErrorMessage {
  message: string
  email?: string
}

export interface CustomJwtPayload extends JwtPayload {
  email?: string
  name?: string
  username?: string
  preferred_username?: string
}

@Component({
  selector: 'anms-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CallbackComponent implements OnInit, AfterViewInit {
  errorMessage$ = new Subject<ErrorMessage>()
  errorMessage: ErrorMessage | null = null
  successMessage: string | null = null

  private isRedirectHandled = false

  constructor(
    private auth0: AuthService,
    private store: Store,
    private router: Router,
    private errorService: ErrorMessageService
  ) {}

  ngOnInit(): void {
    if (this.isRedirectHandled) {
      console.log('Redirect callback already handled')
      return
    }

    this.isRedirectHandled = true

    // const callbackUrl = `${window.location.origin}/callback`

    this.auth0.isAuthenticated$
      .pipe(
        filter((isAuthenticated) => isAuthenticated),
        switchMap(() => this.auth0.user$),
        switchMap((user) =>
          this.auth0.getAccessTokenSilently().pipe(
            tap((token) => {
              const decodedToken = jwtDecode<CustomJwtPayload>(token)
              const response: AuthResponse = {
                access_token: token,
                exp: decodedToken.exp!,
                name: user.name!,
                username: user.email!,
                id: user.sub?.slice(6) || '',
                isAuthenticated: true,
                iat: decodedToken.iat!
              }

              console.log('✅ Authenticated response', response)

              this.store.dispatch(fromAuthActions.successLogin({ response }))
            })
          )
        )
      )
      .subscribe()

    console.log('here callback')

    const queryParams = new URLSearchParams(window.location.search)
    const error = queryParams.get('error')
    const errorDescription = queryParams.get('error_description')

    if (error && errorDescription) {
      const decodedError = decodeURIComponent(error)
      const decodedDescription = decodeURIComponent(errorDescription)

      // Extract email if it exists inside parentheses
      const emailMatch = decodedDescription.match(/\(([^)]+)\)/)
      const extractedEmail = emailMatch ? emailMatch[1] : undefined

      const fullMessage = `${decodedError}: ${decodedDescription}`
      this.errorMessage = { message: fullMessage }

      this.errorService.setError({
        message: fullMessage,
        email: extractedEmail
      })

      console.warn('🚫 Auth0 callback error:', fullMessage)
    }
  }

  ngAfterViewInit(): void {
    console.log('CallbackComponent initialized')
  }

  resendVerificationTicket(email: string, origin: HTMLElement): void {
    origin.setAttribute('disabled', 'true')
    setTimeout(() => origin.removeAttribute('disabled'), 5000)

    this.store.dispatch(fromAuthActions.resendVerificationTicket({ email }))
  }
}
